module.exports = __webpack_public_path__ + "static/media/slider04_tc.87d7c252.png";